module.exports = __webpack_public_path__ + "img/gopipeline.411277c0.svg";